enum NotificationMethods {
    Aplicacao = 'APP',
    Email = 'EMAIL',
}

export default NotificationMethods;
